import { defineMessages } from 'react-intl';

export default defineMessages({
  knowledgeExpertise: {
    id: 'overviewForm.skills',
    defaultMessage: 'Knowledge expertise',
  },
  expertLabel: {
    id: 'overviewForm.expertLabel',
    defaultMessage: 'Expert',
  },
  intermediateLabel: {
    id: 'overviewForm.intermediateLabel',
    defaultMessage: 'Intermediate',
  },
  shallowLabel: {
    id: 'overviewForm.shallowLabel',
    defaultMessage: 'Shallow',
  },
  additionalInformation: {
    id: 'overviewForm.additionalInformation',
    defaultMessage: 'Additional information',
  },
  submitLabel: {
    id: 'overviewForm.submit',
    defaultMessage: 'Submit',
  },
});
